export default {"src":"/_next/static/media/bell.bf79a037.svg","height":512,"width":513};